import React, { FC, ReactNode } from "react";
import clsx from "clsx";

import styles from "./ToolTip.module.scss";

type Props = {
  content: string;
  children: ReactNode;
  isEnabled?: boolean;
  className?: string;
};

const ToolTip: FC<Props> = ({
  content,
  children,
  isEnabled = true,
  className,
}) =>
  isEnabled ? (
    <span className={clsx(styles.container, className)} data-tooltip={content}>
      {children}
    </span>
  ) : (
    <>{children}</>
  );

export default ToolTip;
